import { useCallback } from "react";
import { setTermsAndConditions } from "../helpers/meeting/termsandconditions";
import { useSchedulerStore } from "../state/scheduler.store";
import { validateRoosterLinkHelper } from "../helpers/meeting/validate";
import { handleRoosterLinkValidationErrorMessageState } from "../utils/errorManagement";
import { useTranslation } from "react-i18next";

export const useRoosterLinkValidation = () => {
  const { t } = useTranslation();
  const { clientId, actions, meetingLink, link, user, ui, host } =
    useSchedulerStore();

  const setTnC = useCallback(async () => {
    if (
      clientId &&
      meetingLink?.type === "rooster_links" &&
      link?.userId &&
      link?.linkId &&
      user?.id
    ) {
      await setTermsAndConditions(clientId, actions);
    }
  }, [clientId, actions]);

  const validateLink = useCallback(async () => {
    if (
      meetingLink?.type === "rooster_links" &&
      link?.userId &&
      link?.linkId &&
      user?.id
    ) {
      const { hasError, isCancelled, error } = await validateRoosterLinkHelper({
        personIdentifier: link.userId,
        profileIdentifier: link.linkId,
        userUid: user.id,
        link,
        meetingLink
      });

      if (hasError) {
        actions.setSessionValidation("validation_failed");
      }

      const isProspectLink =
        meetingLink.roosterLinksMeta?.profileType === "prospect";

      handleRoosterLinkValidationErrorMessageState(
        hasError,
        isCancelled,
        error,
        actions,
        ui,
        host,
        isProspectLink,
        t
      );
    }
  }, [actions, meetingLink?.type, link, user]);

  return { setTnC, validateLink };
};
